import RequestAbstract from "./RequestAbstract";

export default class PriceCategories extends RequestAbstract {
    get link() {
        return this.links.priceCategories;
    }

    async getCurrent() {
        return await this.get(this.links.priceCategoriesCurrent);
    }

    async getPriceById(id) {
        const arr = [
            { field: "priceListId", op: "=", value: id },
            { field: "name", op: "=", value: "root" },
        ];

        return this.getAllFiltered([arr]);
    }
}
